/**
 * apps/web-admin/src/components/LanguageSelector.tsx
 * Sprint 99 I.3 — selector de idioma en el header del admin.
 *
 * Dropdown que muestra el locale actual y permite cambiar entre los
 * SUPPORTED_LOCALES definidos en @mibodega/i18n. Persiste en
 * localStorage via i18next-browser-languagedetector.
 */
import { useTranslation } from 'react-i18next';
import { Languages } from 'lucide-react';
import { SUPPORTED_LOCALES, type SupportedLocale } from '@mibodega/i18n';

const LOCALE_LABEL: Record<SupportedLocale, string> = {
  'es-CO': 'Español',
  'en-US': 'English',
};

export function LanguageSelector() {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage ?? i18n.language ?? 'es-CO') as SupportedLocale;

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    void i18n.changeLanguage(e.target.value);
  };

  return (
    <label className="flex items-center gap-1.5 text-xs font-medium text-neutral-600">
      <Languages className="h-4 w-4" aria-hidden="true" />
      <select
        value={SUPPORTED_LOCALES.includes(current) ? current : 'es-CO'}
        onChange={handleChange}
        aria-label="Idioma de la interfaz"
        className="cursor-pointer rounded-md border border-neutral-200 bg-white px-2 py-1 text-xs font-medium text-neutral-700 focus:border-teal-500 focus:outline-none"
      >
        {SUPPORTED_LOCALES.map((loc) => (
          <option key={loc} value={loc}>
            {LOCALE_LABEL[loc]}
          </option>
        ))}
      </select>
    </label>
  );
}
